import { ReactElement, useEffect } from 'react';

import { signInWithHostedUi } from '$shared/auth/auth-service';
import { peekPostLoginRedirectPath } from '$shared/auth/post-login-redirect.utils';

import { Loader } from '$components/loader/loader';

export function SignoutPage(): ReactElement {
  useEffect(() => {
    const redirectToSignin = async () => {
      // This page is Cognito's `redirectSignOut` target - reached after signOut()'s
      // own full-page round trip to the Hosted UI's /logout endpoint and back. Forward any
      // deep link sessionStorage still has (see post-login-redirect.utils.ts) as this next
      // sign-in redirect's OAuth `state`/`customState` too, as an extra safety net.
      await signInWithHostedUi(peekPostLoginRedirectPath() ?? undefined);
    };

    redirectToSignin();
  }, []);

  return <Loader />;
}
